import { render, staticRenderFns } from "./RosterProve.vue?vue&type=template&id=c1152180"
import script from "./RosterProve.vue?vue&type=script&lang=js"
export * from "./RosterProve.vue?vue&type=script&lang=js"
import style0 from "./RosterProve.vue?vue&type=style&index=0&id=c1152180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports